export default __webpack_public_path__ + "static/PPGoshaSans-Bold-34e0a7f531b953786ec408623b1363ba.ttf";